import { Link } from "react-router-dom";
import { Brand } from "@/components/site/SiteNav";

export default function SiteFooter() {
  return (
    <footer className="border-t border-stone-100 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Brand />
            <p className="text-sm text-stone-500 mt-4 leading-relaxed max-w-xs">
              Die digitale Patientenaufnahme – entwickelt gemeinsam mit einer Praxis, für die Praxis.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-stone-400 mb-4">Produkt</div>
            <ul className="space-y-2.5 text-sm text-stone-600">
              <li><Link to="/" className="hover:text-emerald-900">Startseite</Link></li>
              <li><Link to="/preise" className="hover:text-emerald-900">Preise</Link></li>
              <li><Link to="/testzugang" className="hover:text-emerald-900">Testzugang anfragen</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-stone-400 mb-4">Unternehmen</div>
            <ul className="space-y-2.5 text-sm text-stone-600">
              <li><Link to="/ueber-uns" className="hover:text-emerald-900">Über uns</Link></li>
              <li><Link to="/blog" className="hover:text-emerald-900">Blog</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-emerald-900">Datenschutz</Link></li>
              <li><Link to="/agb" data-testid="footer-agb-link" className="hover:text-emerald-900">AGB</Link></li>
              <li><Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-emerald-900">Impressum</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-stone-400 mb-4">Zugang</div>
            <ul className="space-y-2.5 text-sm text-stone-600">
              <li><Link to="/login" className="hover:text-emerald-900">Anmelden</Link></li>
              <li><Link to="/tablet" className="hover:text-emerald-900">Tablet-/Kiosk-Login</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-stone-100 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-400">© {new Date().getFullYear()} LAIzyDocu · DSGVO-konform · Hosting in Deutschland</p>
          <p className="text-xs text-stone-400">Made in Germany 🇩🇪</p>
        </div>
      </div>
    </footer>
  );
}
